module.exports = __webpack_public_path__ + "img/about-family-company.png?169a3a0bfa5d63a414992f66264bfb7a";